import { baseApi } from "../baseApi";

export const picklist = baseApi.injectEndpoints({
     endpoints: (builder) => ({
    postSalesOrderList: builder.mutation({
      query: () => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_sales_order_list`,
        method: 'post'
      })
    }),
    postItemList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_item_list`,
        method: 'post',
        body: data
      })
    }),
    postpicklist: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_pick_list`,
        method: 'post',
        body: data
      })
    }),
    postSalesOrderDetails: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_sales_order_details`,
        method: 'post',
        body: data,
      }),
    }),
    postCreatePicklist: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.create_picklist`,

        method: 'POST',
        body: payload,
      }),
    }),

    getPicklistDetails: builder.query({
      query: ({ doctype, name }) => ({
        url: `/api/method/frappe.client.get?doctype=${doctype}&name=${name}`,
        method: 'GET',
      }),
    }),
    postSubmitPickList: builder.mutation({
      query: (pickListId) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_pick_list`,
        method: 'POST',
        body: { pick_list_id: pickListId },
      }),
    }),
    postUpdatePickList: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_pick_list_with_custom_values`,
        method: 'POST',
        body: payload,
      }),
    }),


    postMappedPicklist: builder.mutation({
      query: (salesOrderId) => ({
        url: `/api/method/frappe.model.mapper.make_mapped_doc`,
        method: 'POST',
        body: {
          method: "stackerbee.utils.sales_order.create_pick_list",
          source_name: salesOrderId,
          selected_children: {},
        },
      }),
    }),


    postActiveSerialNos: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_active_serial_nos`,
        method: 'POST',
        body: data,
      }),
    }),




  }),
});

export const { usePostSalesOrderListMutation, useLazyGetPicklistDetailsQuery, usePostItemListMutation, usePostpicklistMutation, usePostSalesOrderDetailsMutation, usePostCreatePicklistMutation, useGetPicklistDetailsQuery, usePostSubmitPickListMutation, usePostUpdatePickListMutation, usePostMappedPicklistMutation,usePostActiveSerialNosMutation } = picklist;

